import BadgeItem from 'components/BadgesCard/BadgeItem';
import { Empty, Loading } from 'components/LottieFiles';
import Title from 'components/Typography/Title';
import { IMAGE_BASE_URL, PLACE_ID } from 'config/constant';
import { GET_BADGES } from 'config/queries';
import ChevronLeft from 'Icons/ChevronLeft';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import useRewards from 'store/useRewards';
import useUser from 'store/useUser';
import { AllWrapper, BackButton, BadgesGrid, Content } from './Rewards.styles';
import { getBadges } from './services';
import useSound from 'use-sound';
import ClickSound from 'assets/sounds/Tap.wav';

const AllBadges = () => {
  const [playClick] = useSound(ClickSound);
  // states
  const { isLogged } = useUser();
  const { badges } = useRewards();
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const goBack = () => {
    playClick();
    navigate(-1);
  };
  const { t } = useTranslation();
  // get data
  const badgeList = useQuery(GET_BADGES, () => getBadges(PLACE_ID));

  // check if user logged or not

  useEffect(() => {
    if (!isLogged) {
      navigate('/start');
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // check if badges is loaded or is stored on localestorage
    if (badges && !badgeList?.isLoading) {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [badges]);

  return (
    <AllWrapper>
      <BackButton onClick={goBack}>
        <ChevronLeft width="17" height="23" />
      </BackButton>
      <Content>
        <Title renderAs="h1" level={1}>
          {t('meritBadges')}
        </Title>
        {badges && badges?.length > 0 ? (
          <BadgesGrid>
            {badges.map((badge: any, index) => {
              const img = badge?.media[0]?.location;
              return (
                <BadgeItem
                  key={badge?.name + index}
                  badgeImage={IMAGE_BASE_URL + img}
                  className="mb-20"
                  badgeName={badge?.name}
                  badgeDescription={badge?.description}
                />
              );
            })}
          </BadgesGrid>
        ) : loading ? (
          <Loading />
        ) : (
          <Empty />
        )}
      </Content>
    </AllWrapper>
  );
};

export default AllBadges;
